<template>
  <div class="step-form">
    <div class="form-group">
      <label>{{ $t('bo.programs.labelName') }} <span class="required">*</span></label>
      <input
        v-model="store.programName"
        type="text"
        class="input"
        maxlength="200"
        :disabled="store.isArchivedProgram"
        :placeholder="$t('bo.programs.namePlaceholder')"
      />
    </div>

    <ProgramLookupSelect
      v-model="store.goal"
      kind="goals"
      :multiple="false"
      required
      :show-popular-picks="true"
      :label="$t('bo.programs.labelGoal')"
      :placeholder="$t('bo.programs.goalPlaceholder')"
      :disabled="store.isArchivedProgram"
    />

    <div class="form-group">
      <label>{{ $t('bo.common.description') }}</label>
      <textarea
        v-model="store.description"
        class="textarea"
        rows="3"
        maxlength="2000"
        :disabled="store.isArchivedProgram"
      />
    </div>

    <div class="form-group">
      <label>{{ $t('bo.programs.labelCoverImage') }}</label>
      <CoverImageInput v-model="store.coverImageUrl" />
    </div>

    <div class="form-group">
      <label>{{ $t('bo.programs.labelFeedbackMode') }}</label>
      <select
        v-model="store.feedbackMode"
        class="input"
        :disabled="store.isArchivedProgram"
      >
        <option value="">{{ $t('bo.programs.feedbackModeNone') }}</option>
        <option value="mentee_to_mentor">{{ $t('bo.programs.feedbackModeMenteeToMentor') }}</option>
        <option value="mentor_to_mentee">{{ $t('bo.programs.feedbackModeMentorToMentee') }}</option>
        <option value="mentee_mentor">{{ $t('bo.programs.feedbackModeBoth') }}</option>
      </select>
    </div>

    <ProgramLookupSelect
      v-model="store.sectors"
      kind="industries"
      :label="$t('bo.programs.labelIndustries')"
      :placeholder="$t('bo.programs.industriesPlaceholder')"
      :disabled="store.isArchivedProgram"
    />

    <ProgramLookupSelect
      v-model="store.skills"
      kind="skills"
      :label="$t('bo.programs.labelSkills')"
      :placeholder="$t('bo.programs.skillsPlaceholder')"
      :max-items="5"
      :disabled="store.isArchivedProgram"
    />
  </div>
</template>

<script setup>
import { useAdminProgramCreationStore } from '@/stores/adminProgramCreation'
import ProgramLookupSelect from '@/components/common/ProgramLookupSelect.vue'
import CoverImageInput from '@/components/ui/CoverImageInput.vue'

const store = useAdminProgramCreationStore()
</script>

<style scoped>
.step-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.form-group label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.required {
  color: #dc2626;
}

.input,
.textarea,
select.input {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
}

.textarea {
  resize: vertical;
}
</style>
